import { composeValidators, validate } from '@alfa-bank/site-form-helpers/validation/utils';
import { validateNotEmpty } from '@alfa-bank/site-form-helpers/validation/not-empty';

type TValidatorValue = string | undefined;

export const MAX_PROMOCODE_LENGTH = 10;
export const isValidPromocode = (value?: string): boolean => {
    return value?.length === MAX_PROMOCODE_LENGTH;
};

export const validatePromocodeValue = (customMessage?: string) => (value: TValidatorValue) =>
    validate(isValidPromocode(value), 'Вы ввели неверный промокод', customMessage);

export const validatePromocode = (message?: string) =>
    composeValidators(validateNotEmpty(), validatePromocodeValue(message));
